<template>
    <label v-bind:for="name" :class="'main-form__label mt-1 w-100 '+classes" v-on:click="showSelectDialog">
        <div v-if="type === 'select'" class="select-dropdown-select-area"></div>
        <template v-if="default_value">
            <input  v-bind:id="name"
                    v-bind:value="default_value"
                    v-bind:disabled="disabled || type === 'select'"
                    v-bind:class="{'main-form__field': true, 'select-input': type === 'select', 'placeholder': placeholder, 'select-input-standard': styled === 'standard'}"
                    v-bind:autocomplete="autocomplete"
                    v-bind:placeholder="placeholder"
            />
        </template>
        <template v-else>
            <input  v-bind:id="name"
                    v-bind:value="m_value"
                    v-on:input="m_emit"
                    v-bind:disabled="disabled || type === 'select'"
                    v-bind:class="{'main-form__field': true, 'select-input': type === 'select', 'placeholder': placeholder, 'select-input-standard': styled === 'standard'}"
                    v-bind:autocomplete="autocomplete"
                    v-bind:placeholder="placeholder"
            />
        </template>

        <span v-if="label" class="main-form__field__title">
            {{label}}
        </span>

        <div v-if="type === 'password'" v-bind:class="'togglePassword main-form__label__password-eye'+(visible_password ? ' visible' : '')" v-on:click="passwordClick">
            <svg class="password-eye visible-eye" version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 469.333 469.333" xml:space="preserve"><g><g><g><path d="M234.667,170.667c-35.307,0-64,28.693-64,64s28.693,64,64,64s64-28.693,64-64S269.973,170.667,234.667,170.667z"/><path d="M234.667,74.667C128,74.667,36.907,141.013,0,234.667c36.907,93.653,128,160,234.667,160 c106.773,0,197.76-66.347,234.667-160C432.427,141.013,341.44,74.667,234.667,74.667z M234.667,341.333 c-58.88,0-106.667-47.787-106.667-106.667S175.787,128,234.667,128s106.667,47.787,106.667,106.667 S293.547,341.333,234.667,341.333z"/></g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
            <svg class="password-eye invisible-eye" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 469.44 469.44"  xml:space="preserve"><g><g><g><path d="M231.147,160.373l67.2,67.2l0.32-3.52c0-35.307-28.693-64-64-64L231.147,160.373z"/><path d="M234.667,117.387c58.88,0,106.667,47.787,106.667,106.667c0,13.76-2.773,26.88-7.573,38.933l62.4,62.4 c32.213-26.88,57.6-61.653,73.28-101.333c-37.013-93.653-128-160-234.773-160c-29.867,0-58.453,5.333-85.013,14.933l46.08,45.973 C207.787,120.267,220.907,117.387,234.667,117.387z"/><path d="M21.333,59.253l48.64,48.64l9.707,9.707C44.48,145.12,16.64,181.707,0,224.053c36.907,93.653,128,160,234.667,160 c33.067,0,64.64-6.4,93.547-18.027l9.067,9.067l62.187,62.293l27.2-27.093L48.533,32.053L21.333,59.253z M139.307,177.12 l32.96,32.96c-0.96,4.587-1.6,9.173-1.6,13.973c0,35.307,28.693,64,64,64c4.8,0,9.387-0.64,13.867-1.6l32.96,32.96 c-14.187,7.04-29.973,11.307-46.827,11.307C175.787,330.72,128,282.933,128,224.053C128,207.2,132.267,191.413,139.307,177.12z"/></g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
        </div>

        <span v-if="(errors && errors[name]) || hint || error_message" class="invalid-feedback">
            <strong v-if="errors && errors[name]">{{ errors[name][0] }}</strong>
            <strong v-else-if="error_message">{{ error_message }}</strong>
            <div v-else-if="hint">{{ hint }}</div>
        </span>

        <template v-if="type === 'select'">
            <inline-svg class="select-dropdown-arrow" src="/images/down-arrow-filled.svg" aria-label="arrow"></inline-svg>
            <div class="select-options">
                <div class="select-dialog-body">
                    <div class="select-dialog-option" v-for="option in select_options" v-on:click="(event) => setSelectDialogValue(event, option)">
                        {{ option[value_name] }}
                    </div>
                </div>
                <button class="select-dialog-hide-button" v-on:click="hideSelectDialog"></button>
            </div>
        </template>
    </label>
</template>
<script>
    export default {
        model:{
            prop: 'value',
            event: 'input'
        },
        props: {
            name: String,
            value: {
                type: [String, Array, Object, Number],
            },
            default_value: {
                type: [String, Array, Object, Number],
            },
            label: {
                type: String,
                required: false,
            },
            type: {
                type: String,
                required: false,
            },
            type_delay:{
                type: [String, Number],
                required: false,
            },
            errors: {
                type: [Array, Object],
                required: false,
            },
            error_message: {
                type: String,
                required: false,
            },
            select_options:{
                type: Array,
                required: false,
            },
            value_name: {
                type: String,
                required: false,
            },
            additional_handling: {
                type: Function,
                required: false,
            },
            hint: {
                type: String,
                required: false,
            },
            autocomplete: {
                type: String,
                default: 'off'
            },
            placeholder: {
                type: String,
                required: false,
            },
            onSelect: {
                type: Function,
                required: false,
            },
            styled: {
                type: String,
                required: false,
            },
            classes: {
                type: String,
                required: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            inputmask:{
                type: Array,
                required: false,
            }
        },
        data: function () {
            return {
                visible_password: false,
            }
        },
        computed: {
            m_value(){
                if(this.type === 'select'){
                    if((Array.isArray(this.value) || typeof this.value === 'object') && this.value_name) return this.value[this.value_name];
                    return this.value;
                }
                else{
                    return this.value;
                }
            }
        },
        methods:{
            passwordClick(event){
                const input = $('#'+this.name);
                if(input.attr('type') === 'text'){
                    input.attr('type', 'password');
                    event.currentTarget.classList.toggle('visible', false);
                }
                else{
                    input.attr('type', 'text');
                    event.currentTarget.classList.toggle('visible', true);
                }
            },
            m_emit(event){
                this.$emit('input', event.target.value);
            },
            showSelectDialog(){
                if(this.type === 'select'){
                    $('#'+this.name).siblings('.select-options').toggleClass('show', true);
                }
            },
            hideSelectDialog(event){
                event.stopPropagation();
                $('#'+this.name).siblings('.select-options').toggleClass('show', false);
            },
            setSelectDialogValue(event, option){
                this.$emit('input', option);
                this.hideSelectDialog(event);
                $('#'+this.name).siblings('.main-form__field__title').toggleClass('to-top', true);
                if(this.onSelect) this.onSelect(option);
            },
        },
        mounted() {
            if(this.inputmask){
                Inputmask(...this.inputmask).mask(document.querySelectorAll('#'+this.name));
            }

            if(this.additional_handling){
                const input = $('#'+this.name);
                input.keypress(() => {
                    let value = this.additional_handling(input.val());
                    input.val(value);
                    this.$emit('input', value);
                });
                input.blur(() => {
                    let value = this.additional_handling(input.val());
                    input.val(value);
                    this.$emit('input', value);
                });
            }

            setTimeout(() => {
                const input = $('#'+this.name);
                input.attr('name', this.name);
                input.attr('type', this.type);
            }, this.type_delay ? this.type_delay : 0);

            setTimeout(() => {
                $("input.main-form__field").change(function () {
                    if($( this ).val() === ''){
                        $(this).siblings('.main-form__field__title').toggleClass('to-top', false);
                    }
                    else {
                        $(this).siblings('.main-form__field__title').toggleClass('to-top', true);
                    }
                });
                $("input.main-form__field").blur(function () {
                    if($( this ).val() === ''){
                        $(this).siblings('.main-form__field__title').toggleClass('to-top', false);
                    }
                    else {
                        $(this).siblings('.main-form__field__title').toggleClass('to-top', true);
                    }
                });
            }, 1000);
        }
    }
</script>
